import * as types from './mutation-types'
import _ from 'lodash'

const state = {
  unreadCount: 0,
  unread: {
    data: [],
    meta: {
      pagination: {
        total: 0,
      },
    },
  },
  read: {
    data: [],
    meta: {
      pagination: {
        total: 0,
      },
    },
  },
}

const mutations = {
  [types.NOTIFICATION_SET_UNREAD_COUNT](state, count) {
    state.unreadCount = count
  },
  [types.NOTIFICATION_SET_UNREAD_NOTIFICATIONS](state, UnreadNotifications) {
    state.unread = UnreadNotifications
  },
  [types.NOTIFICATION_SET_READ_NOTIFICATIONS](state, ReadNotifications) {
    state.read = ReadNotifications
  },
  [types.NOTIFICATION_SET_NOTIFICATION](state, notification) {
    //Loop through read notifications
    let readIndex = _.findIndex(state.read, function (item) {
      return item.id === notification.id
    })
    if (readIndex >= 0) {
      state.read.splice(readIndex, 1, notification)
    }

    //Loop through unread notifications
    let unreadIndex = _.findIndex(state.unread, function (item) {
      return item.id === notification.id
    })
    if (unreadIndex >= 0) {
      state.unread.splice(unreadIndex, 1, notification)
    }
  },
}

export default {
  state,
  mutations,
}